exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.scrollableArea[data-v-6e647b3e] {\n  display: -ms-flexbox;\n  display: flex;\n  height: 94vh;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  overflow: auto;\n}\n.scrollableArea .scrollThis[data-v-6e647b3e] {\n    overflow: auto;\n    height: 100%;\n}\n.selectedTab[data-v-6e647b3e] {\n  color: #fff;\n  border-bottom: 4px solid #f16c64;\n}\n.centerTab[data-v-6e647b3e] {\n  border-left: 2px solid #222c3c;\n  border-right: 2px solid #222c3c;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6e647b3e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume.vue
// module id = 2786
// module chunks = 0